// Constants
import { GIL_API_CHANNEL } from 'constants/api.constants';

const ONBOARDING_ACCESS_AUTHORIZATION_ENDPOINT = {
  ...GIL_API_CHANNEL,
  absoluteUrl: `https://api.${window.ENVIRONMENT}.cf.zinia.com/cf-api-login/v1/token/tokens-by-claims`,
};

export { ONBOARDING_ACCESS_AUTHORIZATION_ENDPOINT };
